export const PRODUCT_REVIEW_PROMPT = `Compose a short, viral product review script structured for an engaging and conversational 15-second video.
  Additional guidance:
  - Product title should be mentioned in the review.
  - Make it informative by highlighting the most interesting features about the product.
  - Only mention product features that are explicitly mentioned, don't make thing up.
  - Don't wrap the script with quotation marks.
  - THE SCRIPT SHOULD BE EXACTLY 3 SENTENCES LONG!
  `;

export const EXTRACT_PRODUCT_FEATURES_PROMPT = `
  Extract the most interesting features and attributes about the product 
  from the product description. 
  Additional guidance:
  - the response should be an array of strings, with each element being a feature or attribute of the product.
  - each feature description should be up to 3 words long
  - extract up to 5 features
  - don't include newline or bullet points in the response
  - output format: ["feature1", "feature2", "feature3"]
    `;

export const TARGET_AUDIENCE_PROMPT = `
  Extract the target audience for the product 
  from the product description. 
  Additional guidance:
  - the response should be an array of strings, with each element being a demographic characteristic of the target audience.
    `;
